/**
 * Hamburger menu.
 */

document.addEventListener( 'DOMContentLoaded', function () {
	const menu = document.querySelector( '.header__navigation-hamburger' );
	// Early check.
	if ( ! menu ) return;

	const burger = document.querySelector( '.navbar-burger' );
	const body = document.querySelector( 'body' );
	const close = document.querySelector( '.navbar-burger-close' );
	const menuItems = menu.querySelectorAll( '.menu-item-has-children > a' );

	const closeMenuItems = () => {
		menu.classList.add( 'hidden' );
		body.classList.remove( 'overflow-hidden' );
		close.classList.add( 'hidden' );
		burger.classList.remove( 'hidden' );

		burger.removeEventListener( 'click', closeMenuItems, false );
	};

	if ( burger && menu ) {
		burger.addEventListener( 'click', function () {
			menu.classList.remove( 'hidden' );
			body.classList.add( 'overflow-hidden' );
			burger.addEventListener( 'click', closeMenuItems, false );
			close.classList.remove( 'hidden' );
			burger.classList.add( 'hidden' );
		} );
	}

	const closeButtons = document.querySelectorAll( '.navbar-burger-close' );
	[ ...closeButtons ].forEach( ( event ) => {
		event.addEventListener( 'click', closeMenuItems, false );
	} );

	menuItems.forEach( ( item ) => {
		item.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			const parent = this.parentElement;
			parent.classList.toggle( 'open' );
		} );
	} );
} );
